<template>
  <div>
    <el-dialog
      title="请上传缴费凭证"
      :visible.sync="dialogVisible"
      center
      width="450px"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <div class="innerUpload">
        <span>账号：</span>
        <span>0200007609089112580</span>
      </div>
      <div class="innerUpload">
        <span>开户名：</span>
        <span>中国建筑业协会</span>
      </div>
      <div class="innerUpload">
        <span>银行：</span>
        <span>工商银行</span>
      </div>
      <div class="innerUpload">
        <span>开户行：</span>
        <span>工商银行北京紫竹院支行</span>
      </div>
      <div class="innerUpload">
        <span>缴费时间</span>
        <el-date-picker
          v-model="time"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="innerUpload">
        <span>缴费凭证</span>
        <el-upload
          class="avatar-uploader"
          :headers="uploadHeaders"
          :action="upLoadUrl"
          :data="uploadData"
          accept=".png,.jpg,.ipeg"
          :on-success="handleSuccess"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
        </el-upload>
      </div>
      <div>
        <p style="text-align: center;color: red;">缴费请使用银行转账上传转账截图即可（截图需包含转账时间、金额等重要信息，300元/年）</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="primary_btn" @click="testUpload">上传</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { uploadPayRecom } from "../../../api/moudles/user.js";
import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";

export default {
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,
      dialogVisible: false,
      time: "",
      imageUrl: "",
      ids: "",
    };
  },
  methods: {
    testUpload() {
      if (!this.time) {
        this.$message.error("请选择缴费时间");
        return;
      }
      if (!this.imageUrl) {
        this.$message.error("请上传缴费凭证");
        return;
      }
      this.uploadPayRecom();
    },
    async uploadPayRecom() {
      await uploadPayRecom({
        data: {
          payTime: this.time,
          code: this.ids,
          proveImg: this.imageUrl,
        },
        success: (res) => {
          console.log("上传缴费凭证成功", res);
          if (res.code == 200 || res.code == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            setTimeout(() => {
              this.dialogVisible = false;
              this.ids = "";
              this.time = "";
              this.imageUrl = "";
              this.$emit("refresh");
            }, 800);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
    openDialog(id) {
      this.ids = id;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.ids = "";
      this.time = "";
      this.imageUrl = "";
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return isLt2M;
    },
    handleSuccess(file) {
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageUrl = file.data;
    },
  },
};
</script>

<style scoped>
>>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}

>>> .el-dialog__footer {
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.primary_btn {
  background-color: #c22c25;
  color: #fff;
}

.innerUpload {
  display: flex;
  margin-bottom: 20px;
}
.innerUpload span:first-child {
  text-align: right;
}
.innerUpload span {
  min-width: 56px;
  display: inline-block;
  margin-right: 20px;
  line-height: 40px;
}
</style>
